<template>
  <div id="page-wrapper" v-if="loggedIn">
    <div class="item-failed">
      <div class="item-failed__row">
        <img
          src="/static/images/svgs/statement-empty.svg"
          alt="Image"
          class="item-failed__row__image"
        />
        <p class="item-failed__row__title">No Transaction</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "statement-empty",
  computed: {
    ...mapGetters(["loggedIn"])
  }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/EplNewStatementEmpty.vue